module.exports = __webpack_public_path__ + "static/media/15.0b5f126a.jpg";